import { JsonRpcModule } from '../../jrpc/module';

export class KeyValueStoreModule extends JsonRpcModule {
  async hasKey(key: string): Promise<void> {
    return this.channel.call('KeyValueStore.HasKey', [key]);
  }

  async deleteAll(save = false): Promise<void> {
    return this.channel.call('KeyValueStore.DeleteAll', [save]);
  }

  async deleteKey(key: string, save = false): Promise<void> {
    return this.channel.call('KeyValueStore.DeleteKey', [key, save]);
  }

  async getFloat(key: string): Promise<void> {
    return this.channel.call('KeyValueStore.GetFloat', [key]);
  }

  async getInt(key: string): Promise<void> {
    return this.channel.call('KeyValueStore.GetInt', [key]);
  }

  async getString(key: string) : Promise<string> {
    return this.channel.call('KeyValueStore.GetString', [key]);
  }

  async save(): Promise<void> {
    return this.channel.call('KeyValueStore.Save', []);
  }

  async setNumber(key: string, value: number, save = false): Promise<void> {
    if (Number.isInteger(value)) return this.channel.call('KeyValueStore.SetInt', [key, value, save]);
    return this.channel.call('KeyValueStore.SetFloat', [key, value, save]);
  }

  async setString(key: string, value: string, save = false): Promise<void> {
    return this.channel.call('KeyValueStore.SetString', [key, value, save]);
  }
}
